import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const createAccountSlice = createSelector(stateSelector, (state) => state.createAccount);

export const getCreateAccountSubmitted = createSelector(createAccountSlice, ({ submitted }) => submitted);
export const getCreateAccountError = createSelector(createAccountSlice, ({ error }) => error);
export const getCreateAccountSuccess = createSelector(createAccountSlice, ({ success }) => success);
